import { Controller } from "@hotwired/stimulus"
import { activateOPButton } from "@1password/save-button"

// Shows the Save in 1Password button only once 1Password enables it. That takes the
// 1Password extension and a site 1Password approved; until then the button stays
// hidden and copying the token remains the way to save it.
export default class extends Controller {
  static targets = ["wrapper"]

  async connect() {
    await customElements.whenDefined("onepassword-save-button")
    const button = this.element.querySelector("onepassword-save-button")?.shadowRoot?.querySelector("button[data-onepassword-save-button]")
    if (!button) return

    this.observer = new MutationObserver(() => this.reveal(button))
    this.observer.observe(button, { attributes: true, attributeFilter: ["disabled"] })
    this.reveal(button)
    activateOPButton()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  reveal(button) {
    this.wrapperTarget.hidden = button.disabled
  }
}
